import { Flex } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'

export default function Layout() {

  return <Flex as="main" h="100%" alignItems="center" justifyContent="center">
    <Outlet />
  </Flex>

}